<template>
  <div v-if="show" class="app-privacy-statement">
    <div class="app-privacy-statement__inner">
      <div class="app-privacy-statement__close" @click="onHide"></div>
      <div class="app-privacy-statement__info">
        By using our site, you acknowledge that you have read and understand our
        <router-link :to="{ name: 'privacy-policy' }" class="app-privacy-statement__link"
          >Privacy Policy</router-link
        >.
      </div>
      <div class="app-privacy-statement__agree">
        <button class="button button--primary" @click="onAgree">I Agree</button>
      </div>
    </div>
  </div>
</template>

<script src="./app-privacy-statement.js"></script>
<style src="./app-privacy-statement.scss" lang="scss"></style>
